@if (event_id) {
  <app-all-events-participants-table [event_id]="event_id">
  </app-all-events-participants-table>
}
